export { AcceptLanguageInterceptor } from './accept-language.interceptor';
export * from './transloco-initializer';

export const Languages = ['fr', 'en'];
export const DefaultLanguage = 'fr';
